<template>
    <div class="row px-3">
        <!-- die col-x größe noch anpassen-->
        <div :class="(deliveryNoteComment.comment == 'FREIGEGEBEN') ? 'bg-success' : ((deliveryNoteComment.comment == 'GESPERRT') ? 'bg-danger' : 'bg-primary')" v-if="deliveryNoteComment.userId === user_id" class="col-10 text-center m-1 text-white border border-secondary rounded">
            <div class="d-flex justify-content-between">
                <span></span>
                <span style="font-size: 10px;">{{moment(deliveryNoteComment.createdAt).format('HH:mm DD.MM.YYYY')}}</span>
                <!--b-badge :variant="(deliveryNoteComment.comment == 'FREIGEGEBEN') ? 'success' : 'danger'"></b-badge-->

            </div>
            <p class="m-1 text-left">{{deliveryNoteComment.comment}}</p>
        </div>
        <!-- die col-x größe noch anpassen-->
        <div :class="(deliveryNoteComment.comment == 'FREIGEGEBEN') ? 'bg-success' : ((deliveryNoteComment.comment == 'GESPERRT') ? 'bg-danger' : 'bg-secondary')" v-else class="col-10 text-center m-1 ml-auto text-white border border-dark rounded">
            <div class="d-flex justify-content-between">
                <span style="font-size: 10px;">{{shortName}}</span>
                <span style="font-size: 10px;">{{moment(deliveryNoteComment.createdAt).format('HH:mm DD.MM.YYYY')}}</span>
                <!--b-badge :variant="(deliveryNoteComment.comment == 'FREIGEGEBEN') ? 'success' : 'danger'"></b-badge-->
            </div>
            <p class="m-1 text-left">{{deliveryNoteComment.comment}}</p>
        </div>
    </div>
</template>
<script>
export default{
    props:{
        deliveryNoteComment:{
            type: [Object, Array],
            required: true
        },
        users:
        {
            type : Array,
            required: true
        },
        user_id:{
            //type: Number,
            required: true
        }
    },
    computed:{
        shortName(){
            let acronym = this.users.find((user)=>{
                return user.id === this.deliveryNoteComment.userId
            });
            return acronym.shortname;
            
        }
    }
}


</script>